// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"3a671162","374":"c58b755e","777":"481d6e74","787":"3fc82462","903":"8ad1955a","921":"04914625"}[chunkId] + ".chunk.js";
};